import { Divider } from '@fs/zion-ui'
import type { CategoryType } from '@fs/zion-tree-types'
import React, { Fragment } from 'react'
import useQualityIndicatorFlag from '../../data-service/useQualityIndicatorFlag'
import CategorySkeleton from './CategorySkeleton'

// Skeleton for `ResearchHelpContent` / `DismissedHintsContent`. Renders the categories whose
// presence is known without a data call. "Matches From Other Trees" is omitted because it
// depends on a tree-to-tree matches request, and quality score improvements are shown only
// when the quality indicator flag is on.
export default function ResearchHelpContentSkeleton(): JSX.Element {
  const { data: qualityIndicatorFlag } = useQualityIndicatorFlag()

  const categories: CategoryType[] = ['data-problems', 'record-hints', 'research-suggestions']
  if (qualityIndicatorFlag?.isOn) {
    categories.push('quality-score-improvements')
  }

  return (
    <>
      {categories.map((category, index) => (
        <Fragment key={category}>
          {index > 0 && <Divider marginY="xxs" />}
          <CategorySkeleton category={category} />
        </Fragment>
      ))}
    </>
  )
}
